<template>
    <TransitionRoot appear :show="qrcreate.modal_config" as="template">
        <Dialog as="div" @close="qrcreate.modal_config = false" class="relative z-10">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <DialogTitle>
                                <div class="flex justify-between items-center">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        Download Settings
                                    </h3>
                                    <button @click="qrcreate.modal_config = false"
                                        class="flex items-center justify-center p-2">
                                        <XIcon />
                                    </button>
                                </div>
                            </DialogTitle>
                            <div class="mt-6 flex items-center gap-2">
                                <p class="text-sm text-gray-500 flex-shrink-0">
                                    File format:
                                </p>
                                <div class="flex items-center flex-wrap gap-2">
                                    <div class="flex items-center mr-4">
                                        <input type="radio" v-model="format" id="file-png" name="format-file" value="png"
                                            class="w-4 h-4 accent-success bg-gray-100 border-gray-300 focus:ring-success focus:outline-none ">
                                        <label for="file-png"
                                            class="ml-2 rounded-sm font-medium bg-[#87d068] leading-5 px-1.5">
                                            <PngIcon class="text-white" size="20" />
                                        </label>
                                    </div>
                                    <div class="flex items-center mr-4">
                                        <input type="radio" v-model="format" id="file-jpg" name="format-file" value="jpg"
                                            class="w-4 h-4 accent-success bg-gray-100 border-gray-300 focus:ring-success focus:outline-none ">
                                        <label for="file-jpg" class="ml-2 rounded-sm font-medium bg-aqua leading-5 px-1.5">
                                            <JpgIcon class="text-white" size="20" />
                                        </label>
                                    </div>
                                    <div class="flex items-center mr-4 ">
                                        <input type="radio" id="file-svg" name="format-file"  v-model="format"  value="svg"
                                            class="w-4 h-4 accent-success bg-gray-100 border-gray-300 focus:ring-success focus:outline-none ">
                                        <label for="file-svg"
                                            class="ml-2 rounded-sm font-medium bg-[#ff5500] leading-5 px-1.5">
                                            <SvgIcon class="text-white" size="20" />
                                        </label>
                                       
                                    </div>
                                </div>
                            </div>
                            <div class="mt-6 flex items-center gap-2">
                                <p class="text-sm text-gray-500 flex-shrink-0">
                                    Error level:
                                </p>
                                <div class="flex items-center flex-wrap gap-2">
                                    <div class="flex items-center mr-4" v-for="level in levels">
                                        <input :id="'inline-radio' + level.value" type="radio" v-model="error_level"
                                            :value="level.value" name="level-inline-radio-group"
                                            class="w-4 h-4 accent-success bg-gray-100 border-gray-300 focus:ring-success focus:outline-none ">
                                        <label :for="'inline-radio' + level.value"
                                            class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{ level.label
                                            }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-6 flex items-center gap-2" v-if="format!='svg'">
                                <p class="text-sm text-gray-500 flex-shrink-0">
                                    Option size:
                                </p>
                                <div class="flex items-center flex-wrap gap-2">
                                    <div class="flex items-center mr-4 gap-2">
                                        <input type="number" min="10" @change="changeWidth" :value="width"
                                            class="h-10 xs:w-28 w-20 rounded-md bg-gray-200 px-2 outline-none">
                                        <span>&times;</span>
                                        <span>{{ height }}</span>
                                    </div>
                                </div>
                            </div>


                            <div class="mt-6 flex justify-end">
                                <button type="button"
                                    class="inline-flex justify-center rounded-md border border-transparent bg-success px-4 py-2 text-sm font-medium text-white hover:bg-success-tier focus:outline-none focus-visible:ring-2 focus-visible:ring-success-tier focus-visible:ring-offset-2"
                                    @click="SaveConfig()">
                                    Save Settings
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import {
    PngIcon, JpgIcon, SvgIcon, XIcon
} from "vue-tabler-icons"
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from '@headlessui/vue'
import { useQrCreateStore } from '~~/stores/qrcreate';
import { storeToRefs } from "pinia";
import { notify } from "@kyvg/vue3-notification";
const qrcreate = useQrCreateStore()
const error_level = ref(qrcreate.config.qrOptions.errorCorrectionLevel)
const levels = ref<Array<{ label: string, value: string }>>([
    {
        label: "7%",
        value: "L"
    },
    {
        label: "15%",
        value: "M"
    },
    {
        label: "25%",
        value: "Q"
    },
    {
        label: "30%",
        value: "H"
    },
])
const qrstyle = useQrStyle()
const width = ref(qrcreate.download.width)
const height = ref(qrcreate.download.height)
const format = ref(qrcreate.download.format)
const { modal_config } = storeToRefs(qrcreate)
watch(modal_config, (v) => {
    if (v) {
        width.value = qrcreate.download.width
        height.value = qrcreate.download.height
        error_level.value = qrcreate.config.qrOptions.errorCorrectionLevel
        format.value = qrcreate.download.format
    }
})

const SaveConfig = () => {
    qrcreate.modal_config = false
    qrcreate.download.width = width.value
    qrcreate.download.height = height.value
    qrcreate.download.format = format.value
    qrstyle.SaveDownloadFormatConfig(qrcreate.download);
    if (qrcreate.config.qrOptions.errorCorrectionLevel != error_level.value) {
        qrcreate.config.qrOptions.errorCorrectionLevel = error_level.value
        qrstyle.GenerateQrCode()
    }
}
const changeWidth = (e: Event) => {
    var widthLocal = parseInt((e.target as HTMLInputElement).value);
    if (!widthLocal) {
        return;
    }
    if (widthLocal > 6000) {
        notify({
            text: "Please choose width less than 6000px",
            type: "warn"
        })
        return;
    }
    width.value = widthLocal
    height.value = Math.ceil(
        (widthLocal * qrcreate.download.height) / qrcreate.download.width
    );
}
</script>
